<template>
  <div>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" class="ProductDialog"
      :visible.sync="dialogVisible" width="540px" :before-close="handleClose">
      <template #title>
        <div><i class="iconfont icon-sound-filled"></i>产品更新公告</div>
      </template>
      <div class="top" v-if="info.imgHashCode"><img :src="`${previewstatic}?${info.imgHashCode}`" alt=""></div>
      <div class="top" v-else-if="info.hashCode&&info.linkUrl"><img :src="`${previewstatic}?code=${info.hashCode}`" alt=""></div>
      <div class="title">{{ info.title ? info.title : '--' }}</div>
      <div class="text">{{ info.spiritWords ? info.spiritWords : '--' }}</div>
      <div class="date">发布时间：{{ info.createDate ? handleFormatDate1(info.createDate) : '--' }}</div>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="text" class="btn1" @click="close(false)">不再显示</el-button>
          <div>
            <el-button class="btn2" @click="close(1)">稍后提醒</el-button>
            <el-button class="btn3" type="primary" @click="handleAnnouncement(info.id)">
              立即查看
            </el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { previewstatic, onlineUrl } from "@/utils/config";
import { handleFormatDate1 } from '@/utils/handle.js'
import { getReadVersion } from '@/utils/api/dashboard'
import Cookies from 'js-cookie'
export default {
  name: 'ProductDialog',
  props: {
    visible: Boolean,
    info: Object,
  },
  data() {
    return {
      previewstatic,
      dialogVisible: this.visible
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        console.log(this.info)
      }
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    handleClose(done) {
      this.close(false)
    },
    // 公告详情跳转
    handleAnnouncement(id) {
      this.close(2)
    },
    // type 1 存储信息，一个小时后在弹开 2.已读
    async close(type) {
      console.log(type);
      if (!type) {
        await this.getReadVersionFn(this.info.id)
        this.$emit("close")
      } else if (type == 1) {
        // 获取当前时间戳（毫秒）
        const currentTimestamp = Date.now()
        // 加 1 小时（3600 * 1000 毫秒）
        const newTimestamp = currentTimestamp + 3600 * 1000
        Cookies.set("isProduct", JSON.stringify({
          date: newTimestamp,
          id: this.info.id
        }), { expires: 7, domain: '.haizol.com', })
        this.$emit("close")
      } else {
        await this.getReadVersionFn(this.info.id)
        await this.$emit("close")
        if (this.info.linkUrl) {
          window.location.href = this.info.linkUrl
        } else if (this.info.hashCode&&!this.info.linkUrl) {
          window.location.href = `${onlineUrl}/note/preview?id=${this.info.hashCode}&&detailid=${this.info.id}`
        } else {
          window.location.href = `${onlineUrl}/purchase-order/supplier/AnnouncementDetails/${this.info.id}`
        }
     
      }
    },
    handleFormatDate1(date) {
      return handleFormatDate1(date)
    },
    async getReadVersionFn(data) {
      try {
        const params = { id: data }
        const res = await getReadVersion(params)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.ProductDialog {

  .el-dialog {
    border-radius: 8px;

  }

  font-family: 'SourceHanSansCN-Regular';
  border-radius: 8px;

  .el-dialog__header {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.9);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    border-bottom: 1px solid #E7E7E7;
    margin: 0;
    padding: 16px 34px 16px 24px;

    .icon-sound-filled {
      color: #FFA200;
      font-weight: 400;
      margin-right: 8px;
    }

    .el-dialog__headerbtn {
      top: 16px;

      .el-dialog__close {
        color: rgba(0, 0, 0, 0.6);
      }
    }
  }

  .el-dialog__body {
    padding: 16px 24px 24px;

    .top {
      width: 100%;

      img {
        width: 100%;
        max-height: 368px;
      }
    }

    .title {
      color: rgba(0, 0, 0, 0.9);
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 22px;
      margin: 16px 0px 8px;
    }

    .text {
      color: rgba(0, 0, 0, 0.9);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      white-space: pre-wrap;
    }

    .date {
      margin-top: 16px;
      color: rgba(0, 0, 0, 0.4);
      text-align: right;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  .el-dialog__footer {
    padding-top: 0;

    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .btn1 {
        color: rgba(0, 0, 0, 0.6);
        padding: 8px 16px;
        font-size: 14px;
      }

      .btn2 {
        padding: 8px 16px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.9);
      }

      .btn3 {
        background: #0052D9;
        color: #fff;
        font-size: 14px;
        padding: 8px 16px;
      }

      .btn1:hover {
        background-color: #E7E7E7;
      }
    }
  }
}
</style>